const parseDate = (s) => {
  if (!s) return null;
  const d = new Date(`${s}T00:00:00`);
  return Number.isNaN(d.getTime()) ? null : d;
};

const diffDays = (a, b) => {
  const ms = 24 * 60 * 60 * 1000;
  return Math.floor((b.getTime() - a.getTime()) / ms);
};

const InvoiceDocuments = {
  validateRangeRequired: ({ dateFrom, dateTo }) => {
    if (!dateFrom || !dateTo) return { ok: false, error: "Debes seleccionar Desde y Hasta para descargar" };

    const a = parseDate(dateFrom);
    const b = parseDate(dateTo);
    if (!a || !b) return { ok: false, error: "Rango de fechas inválido" };
    if (b < a) return { ok: false, error: "La fecha Hasta no puede ser menor que Desde" };

    const days = diffDays(a, b);
    if (days > 366) return { ok: false, error: "El rango de fechas no puede ser mayor a un año" };

    return { ok: true };
  },

  delay: (ms) => new Promise((res) => setTimeout(res, ms)),

  downloadFile: async (url) => {
    const r = await fetch(url, { credentials: "include" });
    if (!r.ok) throw new Error("No se pudo generar el reporte");

    const blob = await r.blob();

    const cd = r.headers.get("content-disposition") || "";
    const match = /filename="([^"]+)"/i.exec(cd);
    const filename = match?.[1] || "reporte.xlsx";

    const objectUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(objectUrl);
  },
};

export default InvoiceDocuments;
